import { CatalogCheckboxType } from '@/redux/services/catalogApi'
import React from 'react'

interface CheckboxProps {
    item: CatalogCheckboxType,
    updater: (id: number) => void,
    state: number[]
}

const CatalogCheckbox: React.FC<CheckboxProps> = ({ item, updater, state }) => {
    const isChecked = state.find(id => id === item.id)

    return (
        <li>
            <label className="catalog__sort-checkbox">
                <input onClick={() => { updater(item.id) }} checked={isChecked !== undefined && true} type="checkbox" name="matches" value="yes" />
                <span className="catalog__sort-checkbox-icon">
                    <svg width="20" height="20" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 4.25L5.75 8L11 2" stroke="#EAF0FF" strokeWidth="2" strokeLinecap="square" />
                    </svg>
                </span>
                <span className="catalog__sort-checkbox-text">{item.title}</span>
            </label>
        </li>
    )
}

export default CatalogCheckbox
